export class ResponseModel {
    Name: string;
    Message: string;
    HasError: boolean;
}